/**
 * Capitalizes the first letter of each word while preserving the rest of the letters
 * @param {string} str - The input string
 * @returns {string} String with first letters capitalized
 */
export const capitalizeFirstLetters = (str: string | null | undefined): string => {
  if (typeof str !== 'string') return ''

  return str
    .split(' ')
    .map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ')
}
